export const WHAT_SERVICES_INTERESTED_STEP_ID = 'what-service-interested';
export const WHAT_TYPE_WEBSITE_STEP_ID = 'what-type-website';
export const WHEN_START_WORKING_STEP_ID = 'when-start-working';
export const WHEN_START_WORKING_OTHER_STEP_ID = 'when-start-working-other';
export const HOW_MUCH_INVEST_STEP_ID = 'how-much-invest';
export const HOW_MUCH_INVEST_OTHER_STEP_ID = 'how-much-invest-other';
export const WHAT_TYPE_BUSINESS_STEP_ID = 'what-type-business';
export const WHAT_OTHER_SERVICES_STEP_ID = 'what-other-services';
export const PERSONAL_INFO_STEP_ID = 'personal-info';
export const HOW_MANY_PRODUCTS_STEP_ID = 'how-many-products';
export const CUSTOM_SOLUTION_STEP_ID = 'custom-solution';
export const WHAT_TYPE_WEBSITE_UPGRADE_STEP_ID = 'what-type-website-upgrade';
export const WHAT_GOALS_UPGRADE_STEP_ID = 'what-goals-upgrade';
export const HOW_MANY_PRODUCTS_UPGRADE_STEP_ID = 'how-many-products-upgrade';
export const WHAT_SERVICES_INTERESTED_OTHER_STEP_ID = 'what-services-interested-other';
export const ADDITIONAL_INFORMATION_STEP_ID = 'additional-information';

export const REQUEST_QUOTE_FLOW = {
  [WHAT_SERVICES_INTERESTED_STEP_ID]: {
    question: 'What service are you interested in?',
    infoText: 'Select the option based on your needs.',
    answers: [
      { answer: 'Launch a new website', nextStep: WHAT_TYPE_WEBSITE_STEP_ID, icon: 'iconRocket' },
      {
        answer: 'Upgrade existing website',
        nextStep: WHAT_TYPE_WEBSITE_UPGRADE_STEP_ID,
        icon: 'iconWand',
      },
      {
        answer: 'Other services',
        nextStep: WHAT_SERVICES_INTERESTED_OTHER_STEP_ID,
        icon: 'iconList',
      },
    ],
  },
  [WHAT_TYPE_WEBSITE_STEP_ID]: {
    question: 'What type of a website do you need?',
    infoText: 'Select the option based on your needs.',
    answers: [
      {
        answer: 'To represent my business services or myself',
        nextStep: WHEN_START_WORKING_STEP_ID,
        icon: 'iconPortfolio',
      },
      {
        answer: 'To sell products (e-commerce)',
        nextStep: HOW_MANY_PRODUCTS_STEP_ID,
        icon: 'iconShoppingCart',
      },
      { answer: 'Custom solution', nextStep: WHEN_START_WORKING_STEP_ID, icon: 'iconEqualizer' },
    ],
  },
  [WHEN_START_WORKING_STEP_ID]: {
    question: 'When would you like to start working with us?',
    infoText: 'Select the option based on your needs.',
    answers: [
      { answer: 'Within 1 month', nextStep: HOW_MUCH_INVEST_STEP_ID, text: '1' },
      { answer: 'Within 3 months', nextStep: HOW_MUCH_INVEST_STEP_ID, text: '3' },
      { answer: 'Later', nextStep: HOW_MUCH_INVEST_STEP_ID, text: '<' },
    ],
  },
  [WHEN_START_WORKING_OTHER_STEP_ID]: {
    question: 'When would you like to start working with us?',
    infoText: 'Select the option based on your needs.',
    answers: [
      { answer: 'Within 1 month', nextStep: HOW_MUCH_INVEST_OTHER_STEP_ID, text: '1' },
      { answer: 'Within 3 months', nextStep: HOW_MUCH_INVEST_OTHER_STEP_ID, text: '3' },
      { answer: 'Later', nextStep: HOW_MUCH_INVEST_OTHER_STEP_ID, text: '<' },
    ],
  },
  [HOW_MUCH_INVEST_STEP_ID]: {
    question: 'How much would you like to invest?',
    infoText:
      'Please note, this figure only needs to be an estimate and does not affect your quote in any way.',
    answers: [
      { answer: 'Less than 2.500', nextStep: WHAT_TYPE_BUSINESS_STEP_ID, text: '1' },
      { answer: 'Less than 5.000', nextStep: WHAT_TYPE_BUSINESS_STEP_ID, text: '2' },
      { answer: 'More than 5.000', nextStep: WHAT_TYPE_BUSINESS_STEP_ID, text: '3' },
    ],
  },
  [HOW_MUCH_INVEST_OTHER_STEP_ID]: {
    question: 'How much would you like to invest?',
    infoText:
      'Please note, this figure only needs to be an estimate and does not affect your quote in any way.',
    answers: [
      { answer: 'Less than 2.500', nextStep: ADDITIONAL_INFORMATION_STEP_ID, text: '1' },
      { answer: 'Less than 5.000', nextStep: ADDITIONAL_INFORMATION_STEP_ID, text: '2' },
      { answer: 'More than 5.000', nextStep: ADDITIONAL_INFORMATION_STEP_ID, text: '3' },
    ],
    nextStep: ADDITIONAL_INFORMATION_STEP_ID,
  },
  [WHAT_TYPE_BUSINESS_STEP_ID]: {
    question: 'What type of business the website is for?',
    infoText: 'Select the option based on your needs.',
    answers: [
      { answer: 'Personal Project', nextStep: WHAT_OTHER_SERVICES_STEP_ID, icon: 'iconHouse' },
      {
        answer: 'Small Size Business',
        nextStep: WHAT_OTHER_SERVICES_STEP_ID,
        icon: 'iconBuildingSmall',
      },
      {
        answer: 'Medium/Large Size Business',
        nextStep: WHAT_OTHER_SERVICES_STEP_ID,
        icon: 'iconBuildingBig',
      },
    ],
  },
  [WHAT_OTHER_SERVICES_STEP_ID]: {
    question: 'What other services you would like to get?',
    infoText: 'Select multiple options based on your needs.',
    answers: [
      { answer: 'Digital Marketing', nextStep: ADDITIONAL_INFORMATION_STEP_ID },
      { answer: 'Maintenance', nextStep: ADDITIONAL_INFORMATION_STEP_ID },
      { answer: 'SEO', nextStep: ADDITIONAL_INFORMATION_STEP_ID },
      { answer: 'Branding', nextStep: ADDITIONAL_INFORMATION_STEP_ID },
    ],
    nextStep: ADDITIONAL_INFORMATION_STEP_ID,
    multiselect: true,
  },
  [WHAT_SERVICES_INTERESTED_OTHER_STEP_ID]: {
    question: 'What services are you interested in?',
    infoText: 'Select multiple options based on your needs.',
    answers: [
      { answer: 'Digital Marketing' },
      { answer: 'Maintenance' },
      { answer: 'SEO' },
      { answer: 'Branding' },
    ],
    nextStep: WHEN_START_WORKING_OTHER_STEP_ID,
    multiselect: true,
  },
  [HOW_MANY_PRODUCTS_STEP_ID]: {
    question: 'How many products you offer?',
    infoText: 'Select the option based on your needs.',
    answers: [
      { answer: 'Up to 10', nextStep: WHEN_START_WORKING_STEP_ID, text: '10' },
      { answer: 'From 10 to 50', nextStep: WHEN_START_WORKING_STEP_ID, text: '10-50' },
      { answer: 'More than 50', nextStep: WHEN_START_WORKING_STEP_ID, text: '50<' },
    ],
  },
  [HOW_MANY_PRODUCTS_UPGRADE_STEP_ID]: {
    question: 'How many products you offer?',
    infoText: 'Select the option based on your needs.',
    answers: [
      { answer: 'Up to 10', nextStep: WHAT_GOALS_UPGRADE_STEP_ID, text: '10' },
      { answer: 'From 10 to 50', nextStep: WHAT_GOALS_UPGRADE_STEP_ID, text: '10-50' },
      { answer: 'More than 50', nextStep: WHAT_GOALS_UPGRADE_STEP_ID, text: '50<' },
    ],
  },
  [WHAT_TYPE_WEBSITE_UPGRADE_STEP_ID]: {
    question: 'What type of website it is?',
    infoText: 'Select the option based on your needs.',
    answers: [
      {
        answer: 'To represent my business services or myself',
        nextStep: WHAT_GOALS_UPGRADE_STEP_ID,
        icon: 'iconPortfolio',
      },
      {
        answer: 'To sell products (e-commerce)',
        nextStep: HOW_MANY_PRODUCTS_UPGRADE_STEP_ID,
        icon: 'iconShoppingCart',
      },
      { answer: 'Custom solution', nextStep: WHAT_GOALS_UPGRADE_STEP_ID, icon: 'iconEqualizer' },
    ],
  },
  [WHAT_GOALS_UPGRADE_STEP_ID]: {
    question: 'What are the goals of the upgrade?',
    infoText: 'Select the option based on your needs.',
    answers: [
      { answer: 'To upgrade functionality' },
      { answer: 'To upgrade visual look' },
      { answer: 'Other' },
    ],
    nextStep: WHEN_START_WORKING_STEP_ID,
    multiselect: true,
  },
  [ADDITIONAL_INFORMATION_STEP_ID]: {
    question: 'Additional information about the project',
    infoText: 'Please fill any additional information about the project.',
    nextStep: PERSONAL_INFO_STEP_ID,
  },
  [PERSONAL_INFO_STEP_ID]: {
    question: 'Complete the form',
    infoText: 'Please fill your contact information so we could send you a quote.',
    isFinalStep: true,
  },
};
